<div class="relative">
  <p class="absolute z-10 text-white-300 text-xs -top-5" *ngIf="label">{{label}}</p>

  <input [id]="componentId + '-input'" [attr.data-cy]="componentId + '-input'" inputWithComma
    [value]="control.value | number"
    class="bg-white border border-white-900 hover:bg-white-hoverGrey text-sm px-4 py-3 rounded w-full outline-none"
    [placeholder]="placeholder" [formControl]="control" [ngClass]="{'disabled':control.disabled}">
</div>
